/**
 * Simple wrapper for fetch to handle WP REST API requirements
 */
export const api = {
  async post<T>(endpoint: string, data: any): Promise<T> {
    const nonce = (window as any).commonVariables.wpRestApiNonce;
    const baseUrl = (window as any).commonVariables.customRestApiBase;

    const response = await fetch(`${baseUrl}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": nonce,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Bir hata oluştu");
    }

    return response.json();
  },
};
